import React from "react";
import LoginElementContainer from "./LoginElementContainer";
import styled from "@emotion/styled";
import IOButton from "../../UI/Form/Button/IOButton";
import { useLocation } from "react-router";
import { parse } from "qs";
import { useMustConfigure2FA } from "../../hooks/authHooks";
import { useSelector } from "react-redux";
import { ROLE_TENANT_OWNER } from "../../utils/constants/constants";
import Mandatory2FAInfo from "../../UI/TwoFactorAuth/Mandatory2FAInfo";

const Title = styled.p`
  text-transform: uppercase;
`;

const TextContainer = styled.div`
  // The aim is to make sure the container is the same height as the login one.
  height: 140px;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

/**
 * Nags the user about setting up 2FA if not set up yet :)
 */
export default function TwoFactorNudger() {
  const location = useLocation();
  const afterLoginLink =
    parse(location.search, { ignoreQueryPrefix: true }).redirect ??
    localStorage.getItem("redirect") ??
    "/";

  const requiring2FA = useMustConfigure2FA();
  const role = useSelector((state) => state.auth?.role);
  const isTenantOwner = role === ROLE_TENANT_OWNER;

  return (
    <LoginElementContainer>
      <Title>Login Success</Title>

      <TextContainer>
        <p>You have successfully logged in.</p>
        {requiring2FA && isTenantOwner ? (
          <div style={{ marginTop: 8 }}>
            <span style={{ marginRight: 6 }}>
              Two-factor authentication is mandatory for all users.
            </span>
            <Mandatory2FAInfo />
          </div>
        ) : null}
      </TextContainer>

      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-around",
        }}
        data-login-result=""
      >
        <IOButton type="button" smallPadding to="/user-profile">
          Set up Two-Factor Auth
        </IOButton>
        <IOButton
          type="button"
          smallPadding
          cancel
          to={afterLoginLink}
          data-cy="skip-2fa-setup"
          hidden={requiring2FA}
        >
          Skip
        </IOButton>
      </div>
    </LoginElementContainer>
  );
}
